export default __webpack_public_path__ + "b4650889c4910cfd776c7769d9165cff.png";